import axios from 'axios';
import axiosRetry from 'axios-retry';

const appHeaders = {
    'Content-Type': 'application/json'
}


export const getLabels = async (language, dataURL) => {
    if (language && !language.startsWith('en')) {
        dataURL = dataURL.replace("en-us", language);
    }

    try {
        return await axios({
            method: 'get',
            url: dataURL,
            header: appHeaders
        })

    } catch (error) {
        return { error: `Something went wrong, unable to fetch labels: [${error}]` }
    }
}
export const getUserInfo = async (token, selfApi) => {

    try {
        return await axios({
            method: 'get',
            url: selfApi,
            params: {
                token: token,
                f: 'pjson'
            },
            header: appHeaders
        })

    } catch (error) {
        return { error: `Something went wrong, unable to fetch user information: [${error}]` }
    }
}

export const getAccountsInfo = async (userName, token, linkedUsersApi) => {
    let linkedUser = '/linkedUsers';
    let linkedUsersApiEndpoint = linkedUsersApi + `${userName}`+ linkedUser;

        return await axios({
            method: 'get',
            url: linkedUsersApiEndpoint,
            params: {
                token: token,
                f: 'pjson'
            },
            headers: appHeaders
        }).catch(error => {
            console.error("Error occurred during redirecting user to linked account", error)
        })
   
}

export const getAdminInfo = async (token, usersApi) => {

    try {
        return await axios({
            method: 'get',
            url: usersApi,
            params: {
                token: token,
                f: 'pjson',
                num : '10',
                role : 'org_admin',
                sortField : 'created'
            },
            header: appHeaders
        })

    } catch (error) {
        return { error: `Something went wrong, unable to fetch user information: [${error}]` }
    }
}

export const getUserProfile = async (token, userName, profileAPI, updateLastLogin) => {

    let headers = {
        'Content-Type': 'application/json',
        Authorization: `${token}`,
        username: userName,
        updateLastLogin: updateLastLogin
    }

    axiosRetry(axios, { retries: 1 });

    return axios({
        method: 'get',
        url: profileAPI,
        headers: headers,
    }).catch(error => {
        console.error("Error occurred during fetching user profile: ", error)
    });

}

export const updateProfile = async (userData, profileApi) => {

    let headers = {
        'Content-Type': 'application/json',
        Authorization: userData.token,
        username: userData.username
    }

    return axios({
        method: 'post',
        url: profileApi,
        headers: headers,
        data: userData
    }).catch(error => {
        console.error("Error occurred during updating user profile: ", error);
    })

}
export const generateCookieData = (cookieObj) => {
    const data = {
        "firstName": cookieObj.firstName ? cookieObj.firstName : '',
        "lastName": cookieObj.lastName ? cookieObj.lastName : '',
        "userName": cookieObj.userName ? cookieObj.userName : '',
        "email": cookieObj.email ? cookieObj.email : '',
        "token": cookieObj.token,
        "expires": cookieObj.expires,
        "culture": "",
        "customBaseUrl": cookieObj.customBaseUrl,
        "created": Date.now(),
        "persistent": false,
        "ehash": cookieObj.hashedEmail
    }
    return encodeURIComponent(JSON.stringify(data));
}